import { decodeToken } from "react-jwt";

export const getTokenInfo = () => {
  const decodedToken = decodeToken(localStorage.getItem("token"));

  if (decodedToken !== null && decodedToken !== undefined && decodedToken.exp !== null && decodedToken.exp !== undefined && new Date(decodedToken.exp * 1000) > new Date()) {
    return decodedToken;
  }
  else return null;
};

export const validateToken = (token) => {

  const decodedToken = decodeToken(token);


  if (decodedToken.token_type === "forgot_password" && new Date(decodedToken.exp * 1000) > new Date() && decodedToken.email !== "" && decodedToken.email !== undefined && decodedToken.email !== null) {
    return decodedToken.email;
  } else {
    return null;
  }

};

export const showLayout = (location) => {

  if (
    location === "/login" ||
    location === "/forgot-password" ||
    location === "/register" ||
    location === "/reset-password"
  ) {
    return false;
  } else {
    return true;
  }

};

export const logOut = () => {
  localStorage.setItem("token", null);
  window.location.href = "/login";
};